import { Transform, TransformationType, TransformFnParams } from "class-transformer";

export function Default<T>(defaultValue: T | undefined = undefined) {
  function transformer(params: TransformFnParams): any {
    switch (params.type) {
      case TransformationType.CLASS_TO_CLASS:
        return params.obj[params.key];
      case TransformationType.CLASS_TO_PLAIN:
        return params.obj[params.key];
      case TransformationType.PLAIN_TO_CLASS:
        if (!params.value) {
          return defaultValue;
        }
        return params.value;
    }
  }

  return Transform(transformer);
}
